import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'amount-component',
  templateUrl: './amount.component.html',
  styleUrls: ['./amount.component.scss']
})
export class AmountComponent {
  isVisible: boolean = true;
  @Input() set isHide(value: boolean) {
    this.isVisible = value;
  }
  @Input() set value(value: number) {
    let stop = value;
    let cantidad = 0;
    let time = setInterval(() => {
      cantidad = cantidad + stop / 65;

      let _entire = Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS'
      }).format(cantidad);

      let digits = _entire.split(',');

      this.entire = digits[0];
      this.decimal = digits[1];

      if (cantidad >= stop) {
        let _entire = Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS'
        }).format(stop);
        this.entire = _entire.split(',')[0];
        this.decimal = _entire.split(',')[1];

        clearInterval(time);
      }
    }, 2);
  }
  entire: string;
  decimal: string;
}
